'use client';
import { Fragment, type ReactNode } from 'react';
import { useLocation } from 'react-router';

export default function RouteKey({ children }: { children: ReactNode }) {
  const location = useLocation();
  return <Fragment key={location.pathname}>{children}</Fragment>;
}
